/* eslint-disable import/no-default-export */
export default (url: string) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image from ${url}`));
    img.src = url;
  });



// WEBPACK FOOTER //
// ./app/gamma/src/util/wait-for-image-load.ts